import VueLazyLoad from 'vue-lazyload'

export default defineNuxtPlugin((nuxtApp) => {
  console.log('use VueLazyLoad====')
  nuxtApp.vueApp.use(
    VueLazyLoad
    // {
    // preload: 2,
    // filter: {
    //   progressive(listener: any, options: any) {
    //     let param = ''
        // const isCDN = //
    //     const prefix = `${
    //       listener.src.indexOf('?') === -1 ? '?' : '&'
    //     }x-oss-process=image`
    //     if (isCDN.test(listener.src)) {
    //       if (options.supportWebp) {
    //         param += '/format,webp'
    //       }
    //     }
    //     listener.src += prefix + param
    //   },
    // },
    // }
  )
})
